module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1014.8318c8d1.png";